import * as React from 'react'
// libs
import { components, OptionProps } from 'react-select'
// components
import ConditionButton from '../RiskTemplateField/components/ConditionButton'
// views
import { Wrapper, EyeIcon, Container } from './views'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
import { LogicalConditionsContext } from 'containers/Risks/RiskTemplate/Edit/layers/LogicalConditions'
// types
import { IOption } from 'components/FormElements/Select'
import { FieldType, RiskTemplateFormConditionActionType } from 'types/graphql'
// themes
import { colors } from 'themes'
// utils
import { get } from 'lodash'

const getField = (str: string) => {
  const bracketIndex = str.indexOf('[')

  if (bracketIndex !== -1) {
    return str.slice(0, bracketIndex)
  } else {
    return str
  }
}

const ConditionOption: React.FC<OptionProps<IOption> & { value: string; label: string }> = (props) => {
  const { isRiskTemplate, riskTemplate } = React.useContext(RiskTemplateAPIContext)
  const { currentCondition, onOptionVisibilityChange } = React.useContext(LogicalConditionsContext)

  const [isFocused, setIsSelected] = React.useState<boolean>(false)

  const onMouseEnter = () => setIsSelected(true)
  const onMouseLeave = () => setIsSelected(false)

  const isSelected = props.value === get(props, 'selectProps.input.value.value')

  const fieldId = getField(props.selectProps.name.split('.value')[0])

  // @ts-ignore
  const currentField = riskTemplate?.fields.find((f) => f.id === fieldId || f.fieldLinkId === fieldId)

  const showConditions = currentField?.parentFieldId
    ? !riskTemplate?.fields.find((f) => f.id === currentField.parentFieldId && f.fieldType === FieldType.Table)
    : true

  const condition = currentCondition?.actions?.find(
    (a) => a.fieldId === fieldId && a.type === RiskTemplateFormConditionActionType.LimitOptions
  )

  const handleOptionClick = (optionId: string) => (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    onOptionVisibilityChange?.(fieldId, optionId)
  }

  const isOptionInCondition = condition?.value?.includes(props.value)

  return (
    <Wrapper onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} isSelected={isSelected}>
      <components.Option {...props} isFocused={isFocused || isSelected}>
        <Container>
          <span>{props.label}</span>

          {isRiskTemplate && showConditions && (
            <>
              <ConditionButton value={props.value} fieldId={fieldId} label={props.label} />
              {currentCondition && currentCondition.fieldId !== fieldId && props.value && (
                <EyeIcon
                  onClick={handleOptionClick(props.value)}
                  color={isOptionInCondition ? colors.purple300 : colors.gray320}
                />
              )}
            </>
          )}
        </Container>
      </components.Option>
    </Wrapper>
  )
}

export default ConditionOption
